import { useState } from "react";
import SiteHeader from "./SiteHeader";
import { trackEvent } from "../utils/analytics";
import "../styles/components/AgendaPage.css";
import futureForwardImg from "../assets/future-forward.png";

function renderTextWithLineBreaks(value) {
  if (value == null) return null;
  if (typeof value !== "string") return value;

  const parts = value.split(/<br\s*\/?>/gi);
  if (parts.length === 1) return value;

  return (
    <>
      {parts.map((part, index) => (
        <span key={`${index}-${part}`}>
          {index > 0 ? <br /> : null}
          {part}
        </span>
      ))}
    </>
  );
}

function LocationPinIcon(props) {
  return (
    <svg viewBox="0 0 24 24" {...props}>
      <path
        d="M12 22s7-5.35 7-12.1a7 7 0 1 0-14 0C5 16.65 12 22 12 22Z"
        fill="currentColor"
        stroke="currentColor"
        strokeWidth="2.1"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <circle
        cx="12"
        cy="9.9"
        r="2.45"
        fill="var(--color-bg)"
      />
    </svg>
  );
}

const agendaDays = [
  {
    id: "day1",
    label: "DAY 1 | Tuesday, March 10, 2026",
    items: [
      {
        time: "5:00 PM",
        title: "Check-in",
        meta: ["The Ritz-Carlton, Chicago"],
      },
      {
        time: "6:00 PM - 8:00 PM",
        title: "Inside Luxury: An LVMH Experience",
        // meta: ["Louis Vuitton, Tiffany, Dior, Loro Piana"],
      },
      // {
      //   time: "7:00 PM",
      //   title: "Distributor Guests Arrive for <br />Experiential Reception",
      //   meta: ["Louis Vuitton, Tiffany, Dior, Loro Piana"],
      // },
    ],
  },
  {
    id: "day2",
    label: "DAY 2 | Wednesday, March 11, 2026",
    items: [
      {
        time: "9:00 AM – 9:15 AM",
        title: "Ritz-Carlton Line Up: <br />How Values Shape Culture",
        meta: ["The Ritz-Carlton Leadership", "Grand Ballroom"],
      },
      {
        time: "9:15 AM – 9:35 AM",
        title: "Charging Our Future",
        meta: ["C. Gabaldon", "Grand Ballroom"],
      },
      {
        time: "9:35 AM – 10:35 AM",
        title: 'Delivering "Our Value"',
        meta: ["F. Morel, O. Levinson, E. Trawinski", "Grand Ballroom"],
      },
      {
        time: "10:35 AM – 11:05 AM",
        title: "Break / Transition",
        meta: ["Exhibit Hall"],
      },
      {
        time: "11:05 AM – 11:30 AM",
        title: "LVMH Excellence Panel: <br />Translating Luxury <br />Standards into Commercial <br />Excellence",
        meta: ["GMs from each Maison, Moderator: TBC", "Grand Ballroom"],
      },
      {
        time: "11:30 AM – 12:15 PM",
        title: "TBC - Pending Topic",
        meta: ["Grand Ballroom"],
      },
      {
        time: "12:15 PM – 1:30 PM",
        title: "Lunch",
        meta: ["Terrace Garden"],
      },
      {
        time: "1:30 PM – 4:05 PM",
        title: "Brand Presentations <br />– Core Brands",
        list: [
          "1:30 – 1:55 PM: Veuve Clicquot",
          "1:55 – 2:20 PM: Moët & Chandon",
          "2:20 – 2:45 PM: Dom Pérignon",
          "2:45 – 3:05 PM: Break",
          "3:05 – 3:30 PM: Chateau d’Esclans",
          "3:30 – 4:05 PM: Hennessy",
        ],
        meta: ["Brand Teams", "Grand Ballroom"],
      },
      {
        time: "4:05 PM – 4:15 PM",
        title: "Our Future: Message <br />from the Field",
        meta: ["MHUSA Commercial Leadership", "Grand Ballroom"],
      },
      {
        time: "4:15 PM – 5:25 PM",
        title: "Closing Remarks – Day 1",
        meta: ["D. Volpe", "Grand Ballroom"],
      },
      {
        time: "6:00 PM – 10:00 PM",
        title: "Awards Gala Dinner",
        meta: ["Grand Ballroom"],
      },
    ],
  },
  {
    id: "day3",
    label: "DAY 3 | Thursday, March 12, 2026",
    items: [
      {
        time: "9:00 AM – 9:15 AM",
        title: "Opening Remarks & <br />Day 2 Framing",
        meta: ["D. Volpe", "Grand Ballroom"],
      },
      {
        time: "9:15 AM – 9:45 AM",
        title: "2026 Commercial Standards & <br />Expectations",
        meta: ["MHUSA Commercial Leadership", "Grand Ballroom"],
      },
      {
        time: "9:45 AM – 12:30 PM",
        title: "Vignette Experiences: <br />Strategy in Action",
        meta: ["Brand, Commercial, and Education Teams", "Various Rooms"],
        list: [
          "30 Minute immersive vignettes highlighting core features of the 2026 strategy",
          "Innovation",
          "On-Premise Excellence",
          "Commercial Excellence",
          "Wine & Whiskey",
          "Experiential Tastings",
        ],
      },
      {
        time: "12:30 PM – 1:45 PM",
        title: "Lunch",
        meta: ["Terrace Garden"],
      },
      {
        time: "1:45 PM – 2:00 PM",
        title: "Captures from Vignettes",
        meta: ["Grand Ballroom"],
      },
      {
        time: "2:00 PM – 2:30 PM",
        title: "2026 Incentive Kick-Off",
        meta: ["Brands & MH USA Commercial Leadership", "Grand Ballroom"],
      },
      {
        time: "2:30 PM – 2:45 PM",
        title: "Distributor Call to Action & <br />Commitment",
        meta: ["MHUSA Leadership", "Grand Ballroom"],
      },
      {
        time: "2:45 PM – 3:00 PM",
        title: "Closing Remarks",
        meta: ["C. Gabaldon, D. Volpe", "Grand Ballroom"],
      },
    ],
  },
];

export default function AgendaPage() {
  const [openDays, setOpenDays] = useState(["day1"]);

  const toggleDay = (dayId) => {
    const isOpen = openDays.includes(dayId);
    trackEvent("agenda_day_toggle", {
      day_id: dayId,
      action: isOpen ? "collapse" : "expand",
    });
    setOpenDays((prev) =>
      prev.includes(dayId)
        ? prev.filter((id) => id !== dayId)
        : [...prev, dayId]
    );
  };

  return (
    <div className="agenda">
      <SiteHeader />

      <main className="agenda__main">
        <section className="agenda__hero">
          <div className="container agenda__heroInner">
            <div className="agenda__heroKicker">
              2026 MOËT HENNESSY
              <br />
              DISTRIBUTOR CONFERENCE
            </div>
            <h1 className="agenda__heroTitle">Agenda</h1>
            <img
              src={futureForwardImg}
              alt="Future Forward"
              className="agenda__heroImage"
            />
          </div>
        </section>

        <section className="agenda__intro">
          <div className="container agenda__introInner">
            <p className="agenda__introText">
              Three days of inspiring talks, interactive workshops, and valuable networking opportunities.
            </p>
          </div>
        </section>

        <section className="agenda__schedule">
          <div className="container agenda__scheduleInner">
            {agendaDays.map((day) => {
              const isOpen = openDays.includes(day.id);
              return (
                <div className="agenda__day" key={day.id}>
                  <button
                    className="agenda__dayHeader"
                    type="button"
                    aria-expanded={isOpen}
                    onClick={() => toggleDay(day.id)}
                  >
                    <span>{day.label}</span>
                    <span className="agenda__toggle" aria-hidden="true">
                      {isOpen ? "–" : "+"}
                    </span>
                  </button>
                  {isOpen && (
                    <div className="agenda__dayBody">
                      {day.items.map((item, itemIndex) => {
                        const metaLines = item.meta ?? [];
                        const locationLine =
                          metaLines.length > 0 ? metaLines[metaLines.length - 1] : null;
                        const metaBeforeLocation = metaLines.slice(0, -1);

                        return (
                          <div className="agenda__row" key={`${day.id}-${item.time}-${itemIndex}`}>
                            <div className="agenda__time">{item.time}</div>
                            <div className="agenda__detail">
                              <div className="agenda__title">
                                {renderTextWithLineBreaks(item.title)}
                              </div>

                              {metaBeforeLocation.length > 0 && (
                                <div className="agenda__meta agenda__meta--who">
                                  {metaBeforeLocation.map((line, metaIndex) => (
                                    <div
                                      key={`${day.id}-${item.time}-${itemIndex}-meta-${metaIndex}`}
                                      className="agenda__metaLine agenda__metaLine--who"
                                    >
                                      {renderTextWithLineBreaks(line)}
                                    </div>
                                  ))}
                                </div>
                              )}

                              {item.list && (
                                <ul className="agenda__list">
                                  {item.list.map((line, listIndex) => (
                                    <li key={`${day.id}-${item.time}-${itemIndex}-list-${listIndex}`}>
                                      {renderTextWithLineBreaks(line)}
                                    </li>
                                  ))}
                                </ul>
                              )}

                              {locationLine && (
                                <div className="agenda__meta agenda__meta--location">
                                  <div className="agenda__metaLine agenda__metaLine--location">
                                    <LocationPinIcon
                                      className="agenda__metaIcon"
                                      aria-hidden="true"
                                      focusable="false"
                                    />
                                    {renderTextWithLineBreaks(locationLine)}
                                  </div>
                                </div>
                              )}
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  )}
                </div>
              );
            })}

            <div className="agenda__download">
              {/* <p className="agenda__downloadText">Want to keep this schedule handy?</p> */}
              {/* <a
                className="agenda__downloadButton"
                href={`${process.env.PUBLIC_URL}/agenda.pdf`}
                download
              >
                Download Full Agenda (PDF)
              </a> */}
              <p className="agenda__downloadText">
                Stay tuned for forthcoming updates regarding the program and onsite logistics. <br/>For questions, please contact: <a href="mailto:distributorconference2026@moethennessy.com" onClick={() => trackEvent("mailto_click", { link_text: "distributorconference2026@moethennessy.com", link_url: "mailto:distributorconference2026@moethennessy.com", section: "agenda" })}>distributorconference2026@moethennessy.com</a>
              </p>
            </div>
          </div>
        </section>
      </main>
    </div>
  );
}
